// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1w-2";
export var blackBorderOnHover = "_1w-7";
export var cell = "_1w-6";
export var cellContainer = "_1w-3";
export var checked = "_1w-8";
export var disabled = "_1w-5";
export var featuredIconCellContainer = "_1w-9";
export var featuredIconTextContainer = "_1w-b";
export var featuredIconWrapper = "_1w-a";
export var noBorder = "_1w-c";
export var orangeSelectedRow = "_4o-3";
export var overflowableText = "_1w-0";
export var overflowableTextContainer = "_1w-1";
export var row = "_1v-0";
export var rowCheckboxCell = "_1w-4";
export var selectableTable = "_4o-2";